import React from 'react'
import styled from 'styled-components'
import { Title } from '../../atoms/Title'

export const DemoHeaderDescription = () => {
  return (
    <>
      <Title>ハンディを今すぐお試しできます</Title>
      <DescriptionBlock>
        <DescriptionLine>
          来店登録から注文操作までを実際にお試しできます。
          <SubDescription>（累計20回まで）</SubDescription>
        </DescriptionLine>
        <DescriptionLine>
          <DemoSubDescription>
            ※サンプルメニューが設定されています
          </DemoSubDescription>
        </DescriptionLine>
      </DescriptionBlock>
      <SecondDescription>
        すべての機能をご利用いただくにはお申込みが必要です。
      </SecondDescription>
      <CheckDescription>
        導入相談ご希望の場合は、下記にチェックしてください。
      </CheckDescription>
    </>
  )
}

const DescriptionBlock = styled.div`
  margin-top: 16px;
  width: calc(100% - 10px);
  background: #fafafa;
  border-radius: 4;
  text-align: left;
  padding: 5px;
`

const DescriptionLine = styled.div`
  padding: 6px 8px;
  font-size: 14px;
  font-weight: 300;
`

const SubDescription = styled.span`
  margin-left: 4px;
  font-size: 10px;
  font-weight: 300;
`

const DemoSubDescription = styled.span`
  font-size: 12px;
  font-weight: 300;
`

const SecondDescription = styled.div`
  margin-top: 16px;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`

const CheckDescription = styled.div`
  margin-top: 8px;
  font-size: 11px;
  font-weight: 300;
`
